import React from "react"

export const MenuIcon = (props) => {
  const { fill } = props

  return (
    <svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          fill={fill}
          class="st0"
          d="M48.8,71.7h62.3c4.2,0,7.7,3.4,7.7,7.7v1.2c0,4.2-3.4,7.7-7.7,7.7H48.8c-4.2,0-7.7-3.4-7.7-7.7v-1.2
					C41.2,75.2,44.6,71.7,48.8,71.7z"
        />
        <path
          fill={fill}
          class="st0"
          d="M48.8,45h62.3c4.2,0,7.7,3.4,7.7,7.7v1.2c0,4.2-3.4,7.7-7.7,7.7H48.8c-4.2,0-7.7-3.4-7.7-7.7v-1.2
					C41.2,48.4,44.6,45,48.8,45z"
        />
        <path
          fill={fill}
          class="st0"
          d="M48.8,98.5h62.3c4.2,0,7.7,3.4,7.7,7.7v1.2c0,4.2-3.4,7.7-7.7,7.7H48.8c-4.2,0-7.7-3.4-7.7-7.7v-1.2
					C41.2,101.9,44.6,98.5,48.8,98.5z"
        />
      </g>
    </svg>
  )
}

export const HomeIcon = (props) => {
  const { fill } = props

  return (
    <svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={fill}
        class="st0"
        d="m113.2 67.4-30-25.2c-1.8-1.6-4.5-1.6-6.4 0l-30 25.2c-1.1 0.9-1.8 2.3-1.8 3.8v12.5c0 2.8 2.2 5 5 5h21.1c1.7 2.6 4.7 4.3 8 4.3 5.2 0 9.4-4.1 9.5-9.3 0-5.1-4.2-9.3-9.5-9.3-3.4 0-6.3 1.7-8 4.3h-16.1v-5.2l25-21 25 21v27.5h-55c-2.8 0-5 2.2-5 5s2.2 5 5 5h60c2.8 0 5-2.2 5-5v-34.8c0-1.4-0.7-2.8-1.8-3.8z"
      />
    </svg>
  )
}

export const PrevIcon = (props) => {
  const { fill } = props

  return (
    <svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={fill}
        class="st0"
        d="M95.4,115c-1.2,0-2.4-0.4-3.4-1.1L51.2,84.8c-2.7-1.9-3.3-5.5-1.4-8.2c0.4-0.6,0.9-1,1.4-1.4L92,46
				c2.7-1.8,6.4-1.1,8.2,1.6c1.8,2.6,1.2,6.2-1.4,8.1L64.8,80l34.1,24.3c2.7,1.9,3.3,5.6,1.4,8.2C99.1,114.1,97.3,115,95.4,115z"
      />
    </svg>
  )
}

export const NextIcon = (props) => {
  const { fill } = props

  return (
    <svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={fill}
        class="st0"
        d="M59.8,112.5c-1.9-2.7-1.3-6.3,1.4-8.2L95.2,80L61.2,55.6c-2.5-1.9-3.1-5.4-1.4-8.1c1.8-2.7,5.5-3.4,8.2-1.6
				l40.8,29.1c0.6,0.4,1,0.9,1.4,1.4c1.9,2.7,1.2,6.3-1.4,8.2L68,113.9c-1,0.7-2.2,1.1-3.4,1.1C62.7,115,60.9,114.1,59.8,112.5z"
      />
    </svg>
  )
}

export const HelpIcon = (props) => {
  const { fill } = props

  return (
    <svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={fill}
        class="st0"
        d="M79.1,96.5c-4.9,0-8.9-4-8.9-8.9c0-0.7,0.1-1.4,0.3-2.1c0.2-1,0.6-2,0.9-3c1.4-3.5,3.6-6.5,6.5-8.9
				c2.5-2,4.8-4.4,6.8-6.9c1.5-2,2.4-4.4,2.4-6.9c0-6.1-2.6-9.2-7.9-9.2c-2.3-0.1-4.5,0.9-5.9,2.7c-0.6,0.7-1,1.4-1.4,2.2
				c-1.4,3.1-4.6,5.1-8,5h-2.7c-4.9,0-8.9-3.9-8.9-8.8c0-1.4,0.3-2.8,1-4.1c1.2-2.3,2.8-4.3,4.7-6c5-4.5,12.1-6.8,21.2-6.8
				c9.1,0,16.1,2.1,21,6.3c5,4.2,7.4,10.2,7.4,17.9c0,3.2-0.6,6.3-2,9.2c-1.7,3.2-3.8,6-6.5,8.4L92.3,83c-1.8,1.6-3.2,3.6-4.2,5.9
				c-0.1,0.4-0.3,0.7-0.4,1.1C86.7,93.8,83.2,96.4,79.1,96.5L79.1,96.5z M67.9,115c-0.1-2.8,1-5.5,3-7.5c4.2-3.9,10.7-3.9,14.8,0
				c3.9,4.2,3.9,10.7,0,14.9c-4.2,3.9-10.6,3.9-14.8,0C68.9,120.5,67.8,117.7,67.9,115z"
      />
    </svg>
  )
}

export const DownloadIcon = (props) => {
  const { fill } = props

  return (
    <svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">      
			<g>
				<path fill={fill} d="M107,113.5H53.4c-3.3,0-6,2.6-6,6c0,3.3,2.6,6,6,6H107c3.3,0,6-2.6,6-6C113,116.1,110.4,113.5,107,113.5z"/>
				<path fill={fill} d="M76.3,94.3c1,1.2,2.4,1.9,3.9,1.9c1.6,0,3-0.7,3.9-1.9l25.2-31.1c1.2-1.6,1.6-3.6,0.6-5.4
					c-0.8-1.8-2.6-2.9-4.7-2.9H95.1c-1.1,0-2-1-2-2V39.7c0-2.9-2.3-5.1-5.1-5.1H72.3c-2.9,0-5.1,2.3-5.1,5.1v13.2c0,1.1-1,2-2,2H55
					c-2,0-3.8,1.1-4.7,2.9c-0.8,1.8-0.6,3.8,0.6,5.4L76.3,94.3z"/>
			</g>
    </svg>
  )
}

export const ReplayIcon = (props) => {
  const { fill } = props

  return (
    <svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={fill}
        d="M108.9,57.7c-11.9-8.3-22.8-9.2-44.1-3.5l0-9.1c0-1.2-0.6-2.3-1.6-2.9c-1.2-0.7-2.6-0.6-3.6,0.3L40.2,58
				c-0.7,0.6-1.2,1.4-1.3,2.3c0,0.4,0,0.8,0.1,1.2c0.4,1.5,1.4,2.8,2.6,3.7c3.8,3.1,13.7,11,16.9,13.6c0.6,0.5,1.4,0.7,2.2,0.7
				c1.1-0.1,2.4-0.2,3.3-1.4c0.5-0.6,0.7-1.4,0.7-2.2l0-10.2c0.3,0,0.7-0.1,1-0.2c21.2-5.9,28.4-4.3,36.6,1.4
				c11.1,7.7,10.3,20.9,4.8,29.8c-2.7,4.4-7.7,7.6-14.2,9.1c-9.5,2.2-20.4,0.2-29.2-5.3c-2.5-1.6-5.9-1.2-7.8,1.1
				c-2.2,2.7-1.5,6.6,1.4,8.4c8.3,5.3,18.2,8.1,27.8,8.1c3.5,0,7-0.4,10.3-1.1c9.5-2.2,17-7.2,21.4-14.3
				C125.4,89.1,125.3,69.1,108.9,57.7z"
      />
    </svg>
  )
}

export const AudioIcon = (props) => {
  const { fill } = props

  return (
    <svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">
      <g>
				<path fill={fill} d="M44.6,64.2H40c-3.4,0-6.2,2.9-6.2,6.4v20.1c0,3.5,2.8,6.4,6.2,6.4h4.6c3.4,0,6.2-2.8,6.2-6.3V70.6
					C50.8,67.1,48,64.2,44.6,64.2z"/>
				<path fill={fill} d="M83.5,47.9c-2.5-1.1-5.5-0.7-7.5,1L57.1,64.8c-1.3,1.2-2.2,2.9-2.2,4.7v20.6c0,1.8,0.7,3.5,2.2,4.7l18.9,16
					c1.3,1,2.9,1.6,4.5,1.6c1,0,2.1-0.2,3-0.6c2.3-1.1,3.8-3.3,3.8-5.7V53.6C87.3,51.2,85.8,49,83.5,47.9z"/>
				<path fill={fill} d="M108.8,50.8c-2.5-0.7-5.2,0.8-5.9,3.4c-0.7,2.5,0.8,5.2,3.4,5.9c6.4,1.8,11.3,10.2,11.3,19.7
					s-4.7,17.7-11.2,19.5c-2.5,0.8-4,3.5-3.3,6.1c0.6,2.2,2.5,3.5,4.6,3.5c0.5,0,0.8,0,1.5-0.2c10.7-3,18.1-14.9,18.1-28.9
					C127.2,65.8,119.6,53.7,108.8,50.8z"/>
				<path fill={fill} d="M111.4,79.8c0-9.8-5.3-18.2-13.1-20.3c-2.5-0.7-5.2,0.8-5.9,3.4c-0.7,2.5,0.8,5.2,3.4,5.9
					c2.9,0.7,5.9,4.9,5.9,10.9c0,5.9-3,10.1-5.9,10.9c-2.5,0.8-4,3.5-3.3,6.1c0.6,2.2,2.5,3.5,4.6,3.5c0.4,0,0.8-0.1,1.5-0.2
					C106.1,97.9,111.4,89.5,111.4,79.8z"/>
			</g>
    </svg>
  )
}

export const CloseIcon = (props) => {
  const { fill } = props

  return (
    <svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={fill}
        d="M93.4,79.8L110,63.2c1.7-1.7,2.7-4,2.7-6.5s-1-4.7-2.7-6.5c-1.7-1.7-4-2.7-6.5-2.7s-4.7,1-6.5,2.7L80.5,66.9
				L63.9,50.3c-1.7-1.7-4-2.7-6.5-2.7s-4.7,1-6.5,2.7c-1.7,1.7-2.7,4-2.7,6.5s1,4.7,2.7,6.5l16.6,16.6L51,96.4c-1.7,1.7-2.7,4-2.7,6.5
				c0,2.4,1,4.7,2.7,6.5h0v0c1.7,1.7,4,2.7,6.5,2.7c2.4,0,4.7-1,6.5-2.7l16.6-16.6l16.6,16.6c1.7,1.7,4,2.7,6.5,2.7
				c2.4,0,4.7-1,6.5-2.7v0h0c1.7-1.7,2.7-4,2.7-6.5c0-2.4-1-4.7-2.7-6.5L93.4,79.8z"
      />
    </svg>
  )
}

export const ZoomIcon = (props) => {
  const { fill } = props

  return (
    <svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">
      <g>
				<path fill={fill} d="M87.7,46.3c-14.4,0-26.2,11.7-26.2,26.2s11.7,26.2,26.2,26.2s26.2-11.7,26.2-26.2S102.2,46.3,87.7,46.3z
					M87.7,90.2c-9.8,0-17.7-8-17.7-17.7s8-17.7,17.7-17.7s17.7,8,17.7,17.7S97.5,90.2,87.7,90.2z"/>
				<path fill={fill} d="M95,69.2h-4v-4c0-1.8-1.5-3.3-3.3-3.3c-1.8,0-3.3,1.5-3.3,3.3v4h-4c-1.8,0-3.3,1.5-3.3,3.3
					c0,1.8,1.5,3.3,3.3,3.3h4v4c0,1.8,1.5,3.3,3.3,3.3c1.8,0,3.3-1.5,3.3-3.3v-4h4c1.8,0,3.3-1.5,3.3-3.3C98.3,70.6,96.8,69.2,95,69.2z
					"/>
				<path fill={fill} d="M64.7,93.2c-1.6-1.6-4.3-1.6-6,0l-11.4,11.4c-0.8,0.8-1.2,1.9-1.2,3c0,1.1,0.4,2.2,1.2,3l2.3,2.3
					c0.8,0.8,1.9,1.2,3,1.2h0c1.1,0,2.2-0.4,3-1.2L67,101.5c1.6-1.6,1.6-4.3,0-6L64.7,93.2z"/>
			</g>
    </svg>
  )
}




